import { render, staticRenderFns } from "./PrePostObject.vue?vue&type=template&id=86b716f8&scoped=true"
import script from "./PrePostObject.vue?vue&type=script&lang=js"
export * from "./PrePostObject.vue?vue&type=script&lang=js"
import style0 from "./PrePostObject.vue?vue&type=style&index=0&id=86b716f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b716f8",
  null
  
)

export default component.exports